import React from "react";
import { ComparativeDisplayType, PlusOrMinusPerUnit } from "@vp/vp-tokenized-fragment";
export const SecondaryPlusOrMinusPerUnitPrices = ({ choice, locale, currency, fractionDigits, pricePlaceholder, hideZeroPrice = false, }) => {
    const { differentialUnitDiscountPrice, differentialUnitListPrice } = choice;
    const priceDifference = differentialUnitListPrice ?? 0;
    const priceDifferenceDiscounted = differentialUnitDiscountPrice ?? 0;
    if (hideZeroPrice && priceDifference === 0 && priceDifferenceDiscounted === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(PlusOrMinusPerUnit, { placeHolderText: pricePlaceholder, pricingInfo: {
            currency,
            minimumFractionDigits: fractionDigits,
            culture: locale,
            priceDifference,
            priceDifferenceDiscounted,
            comparativeDisplayType: ComparativeDisplayType.CustomerFriendly,
        } }));
};
//# sourceMappingURL=secondary-plus-or-minus-per-unit-prices.js.map